<ng-container *transloco="let tAddRecordContent; read: 'add_record_content'">
    <app-modal-layout
        [containerLayout]="containerLayout"
        [showLoader]="showLoader"
        [errors]="errors"
        (closeModal)="forceWithValidation()"
        class="md:w-[37.5rem]"
    >
        <ng-container title>
            <div>{{ tAddRecordContent('create_new_record') }}</div>
        </ng-container>
        <ng-container headerButtons>
            @if (nameField) {
                <app-tb-button appearance="icon" icon="remove" (click)="pinDraftRecord()">
                    remove
                </app-tb-button>
            }
            <app-tb-button appearance="icon" icon="close" (click)="close()"></app-tb-button>
        </ng-container>
        <app-add-record-settings-section
            [workspaces]="(workspaces$ | async)!"
            [schemas]="(schemas$ | async)!"
            [pickedWorkspaces]="availableWorkspaces"
            [selectedSchemaGuid]="schemaGuid"
            (saveSettings)="saveSettings($event)"
            class="pt-4 block"
        ></app-add-record-settings-section>
        <ng-container>
            @if (nameField && nameControl) {
                <div class="flex flex-wrap mb-4">
                    <app-cell-label [field]="nameField" class="w-full">
                        <app-input-cell-container
                            [field]="nameField"
                            [formControl]="nameControl"
                            [validationErrors]="{
                                required: requiredNameError,
                                maxlength: requiredNameError,
                            }"
                            appearance="create_record"
                        ></app-input-cell-container>
                    </app-cell-label>
                </div>
            }
            @if (descriptionField) {
                <div class="flex flex-wrap mb-4">
                    <app-cell-label [field]="descriptionField" class="w-full">
                        <app-tb-input
                            class="body-1 w-full"
                            [formControl]="descriptionControl!"
                            [placeholder]="tAddRecordContent('full_description')"
                            [errors]="[
                                {
                                    code: 'required',
                                    message: tAddRecordContent('required_description_input'),
                                },
                            ]"
                        ></app-tb-input>
                    </app-cell-label>
                </div>
                @if (richTextField) {
                    <app-cell-label [field]="richTextField" class="w-full">
                        <app-input-cell-container
                            [field]="richTextField"
                            [formControl]="fullDescriptionControl!"
                        ></app-input-cell-container>
                    </app-cell-label>
                }
            }
        </ng-container>
        @if (selectedWorkspace$ | async; as selectedWorkspace) {
            @if (fieldTypes$ | async; as fieldTypes) {
                @if (workspaces$ | async; as workspaces) {
                    <app-fields-collection
                        [accordionContent]="accordionContent"
                        [availableWorkspaces]="availableWorkspaces"
                        [form]="formGroup"
                        [recordFieldValues]="recordFieldValues"
                        [excludedFieldsGuids]="excludedFieldsGuids"
                        [workspaces]="workspaces"
                        [selectedSchema]="schemaGuid"
                        [fieldTypes]="fieldTypes"
                        [selectedWorkspace]="selectedWorkspace"
                    >
                    </app-fields-collection>
                }
            }
        }
        <ng-container buttons>
            <app-modal-layout-buttons [action]="true" [primary]="true" [primaryLonger]="true">
                @if (watchField) {
                    <app-tb-icon-toggle-button
                        action
                        icon="custom_star_outline"
                        toggledIcon="custom_star_full"
                        (toggle)="addToFavorite()"
                        [isActive]="isFavorite"
                        [label]="tAddRecordContent('add_favorite')"
                    >
                    </app-tb-icon-toggle-button>
                }
                <div primary class="flex gap-1 justify-end">
                    <app-tb-button (click)="createRecord()" class="md:flex-1 min-w-[6.25rem]">
                        {{ tAddRecordContent('create') }}
                    </app-tb-button>
                    <app-tb-button-with-options
                        [template]="addTaskMenu"
                        xPosition="before"
                        yPosition="above"
                    ></app-tb-button-with-options>
                </div>
            </app-modal-layout-buttons>
            <ng-template #addTaskMenu let-close="closeFn">
                <app-tb-menu-list>
                    <app-tb-menu-list-item (click)="createAndOpen()">
                        {{ tAddRecordContent('create_and_open') }}
                    </app-tb-menu-list-item>
                    <app-tb-menu-list-item (click)="createAndStartAnother()">
                        {{ tAddRecordContent('create_and_start_another') }}
                    </app-tb-menu-list-item>
                    @if (nameField) {
                        <app-tb-menu-list-item (click)="createAndDuplicate(); close()">
                            {{ tAddRecordContent('create_and_duplicate') }}
                        </app-tb-menu-list-item>
                    }
                </app-tb-menu-list>
            </ng-template>
        </ng-container>
    </app-modal-layout>
</ng-container>
<ng-template
    #accordionContent
    [appTypedTemplate]="contextType"
    let-fieldTypes="fieldTypes"
    let-workspaces="workspaces"
    let-fields="fields"
    let-values="values"
    let-form="form"
    let-groupName="groupName"
>
    <app-record-fields
        [fieldTypes]="fieldTypes"
        [workspacesDictionary]="workspaces"
        [fields]="fields"
        [values]="values"
        [formDirectiveGroup]="form"
        [groupName]="groupName"
    ></app-record-fields>
</ng-template>
